module.exports = __webpack_public_path__ + "static/img/22@2x.1bbd79fc.png";